module.exports = __webpack_public_path__ + "img/mental-future-s.9d696861.svg";